import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  HOME_GET_LIST_PRODUCT_SUBSCRIPTION_BEGIN,
  HOME_GET_LIST_PRODUCT_SUBSCRIPTION_SUCCESS,
  HOME_GET_LIST_PRODUCT_SUBSCRIPTION_FAILURE,
  HOME_GET_LIST_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function getListProductSubscription(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: HOME_GET_LIST_PRODUCT_SUBSCRIPTION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const { product_id, coach_id } = args;
      const doRequest = axios.get(
        `${config.apiRootUrl}/subscriptions/get-list-product-subscription`,
        {
          params: {
            product_id,
            coach_id,
          },
          ...createAxiosConfigWithAuth(getState()),
        },
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_GET_LIST_PRODUCT_SUBSCRIPTION_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_GET_LIST_PRODUCT_SUBSCRIPTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetListProductSubscriptionError() {
  return {
    type: HOME_GET_LIST_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
  };
}

export function useGetListProductSubscription() {
  const dispatch = useDispatch();

  const { getListProductSubscriptionPending, getListProductSubscriptionError } =
    useSelector(
      (state) => ({
        getListProductSubscriptionPending:
          state.home.getListProductSubscriptionPending,
        getListProductSubscriptionError:
          state.home.getListProductSubscriptionError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getListProductSubscription(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetListProductSubscriptionError());
  }, [dispatch]);

  return {
    getListProductSubscription: boundAction,
    getListProductSubscriptionPending,
    getListProductSubscriptionError,
    dismissGetListProductSubscriptionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_LIST_PRODUCT_SUBSCRIPTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getListProductSubscriptionPending: true,
        getListProductSubscriptionError: null,
      };

    case HOME_GET_LIST_PRODUCT_SUBSCRIPTION_SUCCESS:
      // The request is success
      return {
        ...state,
        getListProductSubscriptionPending: false,
        getListProductSubscriptionError: null,
      };

    case HOME_GET_LIST_PRODUCT_SUBSCRIPTION_FAILURE:
      // The request is failed
      return {
        ...state,
        getListProductSubscriptionPending: false,
        getListProductSubscriptionError: action.data.error,
      };

    case HOME_GET_LIST_PRODUCT_SUBSCRIPTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getListProductSubscriptionError: null,
      };

    default:
      return state;
  }
}
